import { useEffect } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ActionTypeEnum, useDetailModel } from "./detailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const InfoBox = () => {

    const { setActionType, actionType, customerInfo, customer } = useDetailModel();

    const onBillingList = () => {
        setActionType(ActionTypeEnum.BILLING_LIST)
    }
    const onBilledList = () => {
        setActionType(ActionTypeEnum.BILLED_LIST)
    }
    const onNoBillList = () => {
        setActionType(ActionTypeEnum.NO_BILL_LIST)
    }

    const classname = (type: ActionTypeEnum) => {
        return 'tab-item ' + (actionType === type ? 'tab-active' : '')
    }

    useEffect(() => {
        customerInfo();
    }, [])

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_LIST}>
                    <Button
                        className={classname(ActionTypeEnum.BILLING_LIST)}
                        type="link"
                        shape="round"
                        onClick={onBillingList}
                    >
                        单据列表
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_BILLED}>
                    <Button
                        className={classname(ActionTypeEnum.BILLED_LIST)}
                        type="link"
                        shape="round"
                        onClick={onBilledList}
                    >
                        开票记录
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_APPLYLIST}>
                    <Button
                        className={classname(ActionTypeEnum.NO_BILL_LIST)}
                        type="link"
                        shape="round"
                        onClick={onNoBillList}
                    >
                        无票申请记录
                    </Button>
                </YhAuth>
            </div>
        </>
    );
    return (
        <YhBox
            title={customer.name ?? ""}
            action={action}
        />
    )
}
